<!-- eslint-disable no-debugger -->
<!-- 轮播、分类图页 引用 -->
<template>
  <div style="width:100%;background-color: #fff;">
    <div id="head">
      <div id="div_logo">
        <img
          @click="jump2ImgTypesPage"
          src="static/images/logo.png"
          title="回到首页"
          style="height:60px; position: relative; z-index:1000;bottom:-10px;"
        />
      </div>
      <div id="head_img_box">
          <!--
            <img src="static/images/head.png" style="height:60px; position: relative;" />
           -->
          <div style="
            font-size: 28px;
            height: 30px;
            line-height: 30px; letter-spacing: -2px;
            font-family: fangsong;">
            中國古代實用圖庫 山川城池編
          </div>
          <div id="div_search">
              <searchForm style="height:40px;" ref="imgsearch"></searchForm>
          </div>
      </div>
      <div id="div_info">
        <div v-if="!loginOk" id="loginOk">
            <div v-show="!loginByPw">
                <loginDialogByTel ref="child1" @changeLoginWayEvent="changeLoginWayFun"></loginDialogByTel>
            </div>
            <div v-show="loginByPw">
                <loginDialogByPw ref="child2" @changeLoginWayEvent="changeLoginWayFun"></loginDialogByPw>
            </div>
       </div>

        <div v-if="loginOk" style="width: 120px;float: right;">
          <i
            @click="openUserCenter()"
            class="el-icon-user-solid"
            style="font-size: 30px;position: relative;top:30px;margin-right: 20px;color:#000;cursor: pointer;"
          >
          </i>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i
                class="el-icon-s-unfold"
                style="font-size: 30px;position: relative;top:30px;cursor: pointer;color:#000;"
              ></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <a @click="jump2ImgTypesPage()"
                  ><el-dropdown-item> 回到首页</el-dropdown-item></a
                >
                <a @click="jump2ReadPan()"
                  ><el-dropdown-item> 检索阅读</el-dropdown-item></a
                ><!--
                <a @click="openShopCenter()"
                  ><el-dropdown-item> 我要购买</el-dropdown-item></a
                >
                -->
                <a @click="openUserCenter()"
                  ><el-dropdown-item> 我的账户</el-dropdown-item></a
                >
                <a @click="openfeedBack()"
                  ><el-dropdown-item> 我要发言</el-dropdown-item></a
                >
                <el-dropdown-item> <logout></logout></el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <!--  -->
      </div>
    </div>
  </div>
</template>

<script>
import logout from './logout/logout'
import searchForm from './rely/singleBoxSearch'
import loginDialogByTel from '@/components/loginAndRegister/loginAndLogout/login/loginByTelAndMsgCode_head'
import loginDialogByPw from '@/components/loginAndRegister/loginAndLogout/login/loginByTelAndPassword _head'
export default {
  components: {
    logout: logout,
    searchForm: searchForm,
    loginDialogByTel: loginDialogByTel,
    loginDialogByPw: loginDialogByPw
  },
  data () {
    return {
      loginByPw: true
    }
  },
  methods: {
    changeLoginWayFun () { // fatherMethod
      this.loginByPw = !this.loginByPw
      if (this.loginByPw) {
        this.$refs.child2.loginCheck()
      } else {
        this.$refs.child1.loginCheck()
      }
    },
    jump2FristPage () {
      this.$store.commit('setIndexViewBackgroundImgState', { imgOneValue: true, imgTwoValue: false }) // 切换首页的底图
      this.$router.push('/').catch(() => {}) // 让vue router帮我们进入目标组件
    },
    jump2ImgTypesPage () {
      this.$store.commit('setIndexViewBackgroundImgState', { imgOneValue: true, imgTwoValue: false }) // 切换首页的底图

      this.$router.push('/').catch(() => {}) // 让vue router帮我们进入目标组件
      // this.$router.push('/imgTypes').catch(() => {}) // 让vue router帮我们进入目标组件
      this.$store.commit('setGlobalObjOfSearchType', 'all')
      this.$store.commit('flipSearchTypeValueAndLabelState')
    },
    openUserCenter () {
      this.$router.push('/userCenter/info').catch(() => {}) // 尝试捕获异常NavigationDuplicated
    },
    jump2ReadPan () {
      // 移除分类属性 默认加载全部分类下的图片
      this.$router.push('/imgList/barrel').catch(() => {})
    },
    openShopCenter () {
      this.$router.push('/userShopping').catch(() => {})
    },
    openfeedBack () {
      this.$router.push('/feedBack').catch(() => {})
    },
    checkUserLoginStateFun () {
      // eslint-disable-next-line no-debugger

      const api = '/md/front/user/loginStatus'
      this.axios.post(api).then(res => {
        if (res.status !== 200) {
          return
        }
        res = res.data
        console.log('每过一分钟检查一次当前登录状态:', res)
        if (res === false) {
          // 未登录
          this.$store.commit('setGlobalObjOfNowUserLoginState', false)

          /*
          this.$router.push('/').catch(() => {})
          this.$alert('超时掉线, 自动返回首页', '提示')
          clearInterval(this.$store.state.globalObj.checkUserLoginStateIntervalAddr)
          console.log('已关闭登录状态检测定时器')
          */
        }
      })
    }
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    // 初始化工作
    clearInterval(this.$store.state.globalObj.checkUserLoginStateIntervalAddr)
    // 创建定时器(在同一个页面等待了 1 分钟, 发送一个请求保持当前链接)
    console.log('创建登录状态检测定时器')
    const addr = setInterval(() => {
      this.checkUserLoginStateFun()
    }, 1 * 60 * 1000) // 每过一分钟
    // 保存到全局vuex
    this.$store.commit('setGlobalObjOfCheckUserLoginStateIntervalAddr', addr)
  },
  computed: {
    loginOk () {
      return this.$store.state.globalObj.nowUserLoginState
    }
  }
}
</script>
<style scoped lang="less">
#head {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#div_logo {
  width: 180px;
  height: 80px;
  vertical-align: middle;
  text-align: left;
  float: left;
}
#div_info {
  width: 120px;
  text-align: right;
  float: right;
  padding-right: 10px;
}

#div_search {
  width: 250px;
  position: absolute;
  right: -250px;
}

#head_img_box{
   width: 400px;
   position: relative;
   display: flex;
   flex-direction: row;
   align-items: center;
   right: 150px;
}

#div_logo {
  cursor: pointer;
}

#bjyc {
  color: #ffffff;
  font-size: 25px;
  position: relative;
  bottom: 20px;
}
</style>
